import { VerificarPermissoes } from './../model/verificarPermissoes.model';

import { Router } from '@angular/router';
import { PermissoesService } from './../service/permissoes.service';
import { Permissoes } from './../model/permissao.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permissao',
  templateUrl: './permissao.component.html',
  styleUrls: ['./permissao.component.css']
})

export class PermissaoComponent implements OnInit {


  public paginaAtual = 1;
  permissoes: Permissoes[] = [];
  vc_nome = '';
  vc_descricao = '';
  page = 1;
  count = 0;
  pageSize = 1;

  constructor(private service: PermissoesService, private router: Router) { }

  ngOnInit(): void {
    // this.listarPermissao();
    this.listarPermissoes();
  }

  parametroSolicitacao(page: number): any {
    let params: any = {};
    if (page) {
      params[`page`] = page;
    }

    return params;
  }

  listarPermissoes(): void {
    const params = this.parametroSolicitacao(this.page);

    this.service.getAll(params).subscribe(
      resp => {
        const { last_page, data } = resp;
        this.permissoes = data;
        this.count = last_page;
      }, error => {
      }
    )
  }

  mudarPagina(event: number): void {
    this.page = event;
    this.listarPermissoes();
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }


  // listarPermissao(): void {
  //   this.service.listarService().subscribe(resp => {
  //     console.log(resp)
  //     this.permissoes = resp;
  //   })
  // }





}
